import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  payrollKpi() {
    return api.get(`/api/v1/statistics/salary-kpi`);
  },
  leaveKpi() {
    return api.get(`/api/v1/statistics/leave-applications-kpi`);
  },
  globalKpi() {
    return api.get(`/api/v1/statistics/global-kpi`);
  },
};
